import { createReducer } from 'redux-act';
import { setCartWidgetVisibility, setPricesCartWidget } from './actions';
export const initialWidgetState = {
  visible: false,
  prices: true
};
const setCartWidgetVisibilityHandler = (state, visible) => {
  if (visible === state.visible) {
    return state;
  }
  return {
    ...state,
    visible
  };
};
const setPricesCartWidgetHandler = (state, showPrices) => {
  if (showPrices === state.prices) {
    return state;
  }
  return {
    ...state,
    prices: showPrices
  };
};
const reducer = createReducer({
  [setCartWidgetVisibility]: setCartWidgetVisibilityHandler,
  [setPricesCartWidget]: setPricesCartWidgetHandler
}, initialWidgetState);
export default reducer;